// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-list[data-v-53dc98c0]{display:flex;flex-direction:column;gap:var(--size-3);list-style:none;margin:0;padding:0}@media (min-width:75rem){.navigation-list[data-v-53dc98c0]{flex-direction:row;justify-content:space-between}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
